<template>
  <div class="slidePage">
    <div class="white_layer">
    <el-carousel ref="nop" arrow="never" height="106px" :autoplay="type" :indicator-position="auditList.length>1?'':'none'">
        <el-carousel-item class="el_carousel__item_style" v-for="(item,index) in auditList" :key="index" >
          <v-touch :swipe-options="{direction: 'horizontal'}" v-on:swipeleft="swiperleft(index)" v-on:swiperight="swiperright(index)" class="wrapper">
            <div class="demo-image" >
              <div class="block" v-for="(nameshow, number) in item.billName" :key="number">
                <el-image
                    @click="auditClick(item.entityId[number])"
                    style="width: 42px; height: 42px"
                    :src="item.url[number]"
                    ></el-image>
                <span class="demonstration">{{ nameshow }}</span>
              </div>
          </div>
          </v-touch>
        </el-carousel-item>
    </el-carousel>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: ['billTypes','model', 'KDApi'],
  /*props: {
    billNames:Array,
  },*/
  computed: {},
  watch: {
    billTypes:function (billShow){
      if(billShow != null){
        let auditTempList = [];
        if(billShow.length < 5){
          auditTempList[0] ={
            "billType":[],
            "billName": [],
            "entityId": [],
            "url":[],
          }
          for(let i =0; i<billShow.length; i++){
            auditTempList[0].billType.push(billShow[i].billType);
            auditTempList[0].billName.push(billShow[i].billName);
            auditTempList[0].entityId.push(billShow[i].entityId);
            auditTempList[0].url.push(this.URLMap[billShow[i].billType]);
          }
        }else{
          auditTempList[0] ={
            "billType":[],
            "billName": [],
            "entityId": [],
            "url":[],
          }
          for(let i = 0; i < 4; i++){
            auditTempList[0].billType.push(billShow[i].billType);
            auditTempList[0].billName.push(billShow[i].billName);
            auditTempList[0].entityId.push(billShow[i].entityId);
            auditTempList[0].url.push(this.URLMap[billShow[i].billType]);
          }
          auditTempList[1] ={
            "billType":[],
            "billName": [],
            "entityId": [],
            "url":[],
          }
          for(let i = 4; i < billShow.length; i++){
            auditTempList[1].billType.push(billShow[i].billType);
            auditTempList[1].billName.push(billShow[i].billName);
            auditTempList[1].entityId.push(billShow[i].entityId);
            auditTempList[1].url.push(this.URLMap[billShow[i].billType]);
          }
          console.log("auditTempList[1]:"+auditTempList[1].billName.length)
        }
        this.auditList = auditTempList;
      }else{
        let auditTempList = [];
        auditTempList[0] ={
          "billType":["Z"],
          "billName": [this.KDApi.getLangMsg(this.model, 'audit')],
          "url":[this.URLMap["Z"]],
          "entityId":["test-Z"],
        }
        this.auditList = auditTempList;
      }

    },
  },
  data() {
    return {
      type: false,
      URLMap:{"Z": this.KDApi.getNameSpace(this.model) + 'imgs/hr_sp.png',
        "A": this.KDApi.getNameSpace(this.model) + 'imgs/hr_xj.png',
        "B": this.KDApi.getNameSpace(this.model) + 'imgs/hr_jb.png',
        "C": this.KDApi.getNameSpace(this.model) + 'imgs/hr_tb.png',
        "D": this.KDApi.getNameSpace(this.model) + 'imgs/hr_cc.png',
        "E": this.KDApi.getNameSpace(this.model) + 'imgs/hr_bq.png'},
      auditList:[]/* [{
        "id":["Z","A","B","C"],
        "name": ['审批', '休假', '加班','调班'],
        "url":[this.KDApi.getNameSpace(this.model) + 'imgs/hr_sp.png',this.KDApi.getNameSpace(this.model) + 'imgs/hr_xj.png',this.KDApi.getNameSpace(this.model) + 'imgs/hr_jb.png',this.KDApi.getNameSpace(this.model) + 'imgs/hr_tb.png'],
      }, {
        "id":["D","E"],
        "name": ['出差', '补签'],
        "url":[this.KDApi.getNameSpace(this.model) + 'imgs/hr_cc.png',this.KDApi.getNameSpace(this.model) + 'imgs/hr_bq.png'],
      }]*/,
    }
  },
  mounted() {

  },
  methods: {

    // 设置滑动切换轮播图
    swiperleft: function (index) {
      // 下一页
      this.$refs.nop.next();
    },
    swiperright: function (index) {
      // 上一页
      this.$refs.nop.prev();
    },
    /**
     * 点击事件，跳转
     * @param id
     */
    auditClick(billType) {
      console.info(billType);
      this.model.invoke("clickAudit", billType);
      // alert(msg);
    }

}
}
</script>
<style lang="less" scoped>
.slidePage {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  font-size: 14px;
  background-color: #EEEEEE;
  width: 100%;
  height: 106px;

  .demo-image{
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .block{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 25%;
    margin-top: 12px;
  }

  .demonstration{
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #212121;
    letter-spacing: 0;
    text-align: center;
    line-height: 16px;
    font-weight: 400;
    margin-top: 8px;
  }
  .white_layer {
    background-color: #fff;
    height: 100%;
    width: 100%;
  }


  .a_div_label_top {
    height: 28px;
    width: 100%;
    font-size: 12px;
  }

  .a_div_label {
    height: 28px;
    width: 96%;
    margin-left: 18px;
    font-size: 12px;
  }

  .div_lable_font {
    height: 100px;
    border: 1px solid #1e1e1e;
  }

  .el_carousel__item_image {
    width: 160px;
    height: 160px;
    margin-top: 20px;
  }

  .el_carousel__item_style {
    text-align: center;
    height: 106px;
  }


  /deep/.el-carousel__indicators--horizontal {

    .el-carousel__indicator--horizontal{
      padding: 12px 2px !important;
    }

    .el-carousel__indicator--horizontal button {
      width: 4px;
      height: 4px;
      background: #d8d8d8;
      border-radius: 2.5px;
    }

    .el-carousel__indicator--horizontal.is-active button {
      width: 10px;
      height: 4px;
      background: #276ff5;
      border-radius: 2.5px;
    }
  }

}


</style>